<template>
  <div v-if="showForm" class="container">
    <transition name="fade" mode="out-in">
      <div class="success text-center" v-if="success" key="success">
        <div class="h2 -upper title">{{ $t('Contact us') }}</div>
        <div class="wysiwyg h3">{{ $t('Your contact request has been sent') }}</div>
      </div>
      <div v-else key="form">
        <div class="title h2 text-center -upper">{{ $t('Contact us') }}</div>
        <div class="subtitle h3 text-center -upper">{{ $t('Please fill in the fields below') }}</div>
        <slot></slot>
        <div class="row">
          <form class="form col-12" :class="{ ['col-md-8 col-lg-6 offset-md-2 offset-lg-3']: !this.item.containerFullWidth }" @submit.prevent="submit" novalidate>
            <strong class="form-heading font-small-title">{{ $t('Personal information') }}</strong>
            <base-select id="title" name="title" v-model="title" autocomplete="honorific-prefix"
              :placeholder="$t('Title') + ' *'" :validations="[
                {
                  condition: $v.title.$error && !$v.title.required,
                  text: $t('Field is required.'),
                },
              ]" :required="true" :options="[
  { value: 'mr', label: $t('Mr.') },
  { value: 'ms', label: $t('Mrs.') },
]" />

            <template v-if="currentCountry === 'JP'">
              <base-input type="text" id="surname" :maxlength="MAX_LAST_NAME_LENGTH" name="surname" autocomplete="given-name" v-model="surname"
              @blur="$v.surname.$touch()" :placeholder="$t('Last name') + ' *'" :validations="[
                {
                  condition: !$v.surname.required && $v.surname.$error,
                  text: $t('Field is required.'),
                },
              ]" :required="true" />
              <base-input id="name" :maxlength="MAX_FIRST_NAME_LENGTH" type="text" name="name" autocomplete="family-name" v-model="name"
              @blur="$v.name.$touch()" :placeholder="$t('First name') + ' *'" :validations="[
                {
                  condition: !$v.name.required && $v.name.$error,
                  text: $t('Field is required.'),
                },
              ]" :required="true" />
              <base-input
                type="text"
                id="kanjiLastName"
                name="kanjiLastName"
                v-model="kanjiLastName"
                @blur="$v.kanjiLastName.$touch()"
                :placeholder="$t('Local last name')"
              />
              <base-input
                type="text"
                id="kanjiFirstName"
                name="kanjiFirstName"
                v-model="kanjiFirstName"
                @blur="$v.kanjiFirstName.$touch()"
                :placeholder="$t('Local first name')"
              />
            </template>
            <template v-else>
              <base-input id="name" :maxlength="MAX_FIRST_NAME_LENGTH" type="text" name="name" autocomplete="family-name" v-model="name"
              @blur="$v.name.$touch()" :placeholder="$t('First name') + ' *'" :validations="[
                {
                  condition: !$v.name.required && $v.name.$error,
                  text: $t('Field is required.'),
                },
              ]" :required="true" />
            <base-input type="text" id="surname" :maxlength="MAX_LAST_NAME_LENGTH" name="surname" autocomplete="given-name" v-model="surname"
              @blur="$v.surname.$touch()" :placeholder="$t('Last name') + ' *'" :validations="[
                {
                  condition: !$v.surname.required && $v.surname.$error,
                  text: $t('Field is required.'),
                },
              ]" :required="true" />
            </template>

            <template v-if="item.fullAddress || isSalesforceForm">
              <base-input type="text" id="street" name="street" v-model="street" autocomplete="address-line1"
                :placeholder="$t('Street line 1') + ' *'" :validations="[
                  {
                    condition: !$v.street.required && $v.street.$error,
                    text: $t('Field is required.'),
                  },
                ]" />

              <base-input type="text" id="additionalStreet" name="additionalStreet" autocomplete="address-line2"
                v-model="additionalStreet" :placeholder="$t('Street line 2')" />

              <base-select id="country" name="country" :options="countryOptions" :selected="country"
                :placeholder="$t('Country/Region') + ' *'" v-model="country" autocomplete="country-name" :validations="[
                  {
                    condition: !$v.country.required && $v.country.$error,
                    text: $t('Field is required.'),
                  },
                ]" :required="true" /><base-select id="region" name="region" :options="regionOptions"
                :selected="region" :placeholder="$t('State') + ' *'" v-model="region" autocomplete="region"
                v-if="country === 'US'" :validations="[
                  {
                    condition: !$v.region.required && $v.region.$error,
                    text: $t('Field is required.'),
                  },
                ]" />

              <div class="row">
                <div class="col-4">
                  <base-input type="text" id="postcode" name="postcode" autocomplete="postcode" v-model="postcode"
                    :placeholder="$t('Zip code') + ' *'" :validations="[
                      {
                        condition: !$v.postcode.required && $v.postcode.$error,
                        text: $t('Field is required.'),
                      },
                    ]" />
                </div>
                <div class="col-8">
                  <base-input type="text" id="city" name="city" autocomplete="address-level2" v-model="city"
                    :placeholder="$t('City') + ' *'" :validations="[
                      {
                        condition: !$v.city.required && $v.city.$error,
                        text: $t('Field is required.'),
                      },
                    ]" />
                </div>
              </div>
            </template>
            <template v-else>
              <base-select id="country" name="country" :options="countryOptions" :selected="country"
                :placeholder="$t('Country/Region') + ' *'" v-model="country" autocomplete="country" :validations="[
                  {
                    condition: !$v.country.required && $v.country.$error,
                    text: $t('Field is required.'),
                  },
                ]" />
            </template>
            <base-input id="email" type="email" name="email" autocomplete="email" v-model="email"
              @blur="$v.email.$touch()" :placeholder="$t('E-mail address') + ' *'" :validations="[
                {
                  condition: !$v.email.required && $v.email.$error,
                  text: $t('Field is required.'),
                },
                {
                  condition: !$v.email.email && $v.email.$error,
                  text: $t('Please provide valid e-mail address.'),
                },
              ]" :required="true" />
            <base-phone id="phone" type="text" name="phone" autocomplete="tel-national" v-model="phone"
              :phoneIndic="phoneIndic" @phoneIndic="
                (v) => {
                  phoneIndic = v
                }
              " @blur="$v.phone.$touch()" :placeholder="$t('Phone N°') + ' *'" :validations="[
                {
                  condition: !$v.phone.required && $v.phone.$error,
                  text: $t('Field is required.'),
                },
                {
                  condition: $v.phoneIndic.$error && $v.phoneIndic.$error,
                  text: $t('Phone extension is required.'),
                },
              ]" :required="true" />
            <strong class="form-heading font-small-title">{{ $t('Your request') }}</strong>
            <base-select id="subject" name="subject" :options="subjects" :selected="subject"
              :placeholder="$t('Subject') + ' *'" v-model="subject" autocomplete="subject" :validations="[
                {
                  condition: !$v.subject.required && $v.subject.$error,
                  text: $t('Field is required.'),
                },
              ]" :required="true" />

            <base-select id="subject" name="subject" v-if="subject && subsubjects && subsubjects.length" :options="subsubjects" :selected="subsubject"
              :placeholder="$t('Sub Subject') + ' *'" v-model="subsubject" autocomplete="subsubject" :validations="[
                {
                  condition: !$v.subsubject.required && $v.subsubject.$error,
                  text: $t('Field is required.'),
                },
              ]" :required="true" />
            <base-textarea id="message" name="message" v-model="message"
              :placeholder="$t('Description of your request') + ' *'" :validations="[
                {
                  condition: !$v.message.required && $v.message.$error,
                  text: $t('Field is required.'),
                },
              ]" :required="true" />

              <template v-if="item.shippingKit">
                <div class="return-formfield" >
                  <base-input id="watchRef" type="text" name="watchRef" autocomplete="watchRef" v-model="watchRef"
                @blur="$v.watchRef.$touch()" :placeholder="$t('Watch reference') + ' *'" :validations="[
                  {
                    condition: !$v.watchRef.required && $v.watchRef.$error,
                    text: $t('Field is required.'),
                  }
                ]" :required="true" />
                <base-input id="dialColor" type="text" name="dialColor" autocomplete="dialColor" v-model="dialColor"
                @blur="$v.dialColor.$touch()" :placeholder="$t('Dial color') + ' *'" :validations="[
                  {
                    condition: !$v.dialColor.required && $v.dialColor.$error,
                    text: $t('Field is required.'),
                  }
                ]" :required="true" />
                <div class="watch-attachment">
                  <h3 class="-upper text-center">{{$t('Please upload picture of your timepiece')}}</h3>
                  <div class="row">
                    <div class="col-6 text-center">
                      <h3 class="-upper font-small-title">{{$t('Front of your timepiece')}}</h3>
                      <div
                        class="picture"
                        :class="{'-error': $v.attachment.$error && !$v.attachment.required}"
                      >
                        <transition name="fade">
                          <img v-if="attachmentSrc" :src="attachmentSrc" :alt="$t('Front')" />
                        </transition>
                        <p>{{$t('Upload a picture of your timepiece indicating 9:35 time')}}</p>
                        <input
                          type="file"
                          id="attachment"
                          ref="attachment"
                          name="attachment"
                          accept="image/*"
                          @change="processFile($event, 'attachment')"
                        />
                        <label for="attachment" class="btn browse -block font-btn">{{ $t('Browse') }}</label>
                        <div class="form-error">{{ $t('Field is required.') }}</div>
                        <p>{{$t('See example on the right')}}</p>
                        <transition name="fade">
                          <button
                            v-if="attachmentSrc"
                            @click="deleteImg('attachment')"
                            type="button"
                            class="trash"
                          >
                            <i class="icon-poubelle"></i>
                          </button>
                        </transition>
                      </div>
                    </div>
                    <div class="col-6">
                      <lazy-picture :item="{image: exampleImage}" preserve-ratio="true" />
                    </div>
                  </div>
                </div>
                </div>
              </template>

            <div class="toggle-line" :class="{ '-error': !$v.conditions.required && $v.conditions.$error }">
              <Toggle v-model="conditions" id="conditions"></Toggle>
              <NoSSR>
                <label class="font-smaller" for="conditions"
                  v-html="$t('I accept the terms of use', { href: localizedUrl + '/page/terms' })">*</label>
              </NoSSR>
              <div class="form-error">
                <span>{{ $t('Field is required.') }}</span>
              </div>
            </div>
            <NewsletterBox v-model="is_subscribed" />
            <div class="recaptcha font-smaller" v-html="
              $t('This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.', {
                hrefPrivacy: 'https://policies.google.com/privacy',
                hrefTerms: 'https://policies.google.com/terms',
              })
            "></div>
            <CustomLoader :is-loading="loading">
              <button class="btn -block font-btn" type="submit">{{ $t('Send') }}</button>
            </CustomLoader>
          </form>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import BaseInput from '../components/form/BaseInput'
import BasePhone from '../components/form/BasePhone'
import BaseSelect from '../components/form/BaseSelect'
import BaseTextarea from '../components/form/BaseTextarea'
import Toggle from '../components/form/Toggle'
import NewsletterBox from '../components/form/NewsletterBox'
import { required, email, sameAs, requiredIf } from 'vuelidate/lib/validators'
import { TaskQueue } from '@vue-storefront/core/lib/sync'
import config from 'config'
import { mapActions, mapGetters } from 'vuex'
import { ReadyHook } from 'vue-asyncready'
import NoSSR from 'src/themes/zenith/node_modules/vue-no-ssr'
import { newsletter, MAX_FIRST_NAME_LENGTH, MAX_LAST_NAME_LENGTH, newsletterEventObject, contactRequestObj } from '../utilities'
import { contactCountries, saveAttachement } from '../utilities/contact'
import LazyPicture from './utils/LazyPicture.vue'
import CustomLoader from './utils/CustomLoader.vue'

const USStates = () => import('../resource/json/us-states.json').then((module) => module.default)

export default {
  components: {
    BaseInput,
    BaseSelect,
    BasePhone,
    Toggle,
    BaseTextarea,
    NoSSR,
    LazyPicture,
    CustomLoader,
    NewsletterBox
  },
  props: ['item', 'pagePosition', 'siblings-components'],
  mixins: [ReadyHook],
  validations: {
    title: {
      required,
    },
    name: {
      required,
    },
    surname: {
      required,
    },
    phone: {
      required,
    },
    phoneIndic: {
      required,
    },
    city: {
      required: requiredIf(function () {
        return this.item.fullAddress
      }),
    },
    postcode: {
      required: requiredIf(function () {
        return this.item.fullAddress
      }),
    },
    street: {
      required: requiredIf(function () {
        return this.item.fullAddress
      }),
    },
    watchRef: {
      required: requiredIf(function () {
        return this.item.shippingKit
      })
    },
    dialColor: {
      required: requiredIf(function () {
        return this.item.shippingKit
      })
    },
    attachment: {
      required: requiredIf(function () {
        return this.item.shippingKit
      })
    },
    region: {
      required: requiredIf(function () {
        return this.item.fullAddress && this.country === 'US'
      }),
    },
    country: {
      required,
    },
    subject: {
      required,
    },
    subsubject: {
      required: requiredIf(function () {
        return this.subsubjects && this.subsubjects.length
      }),
    },
    email: {
      required,
      email,
    },
    message: {
      required,
    },
    conditions: {
      sameAs: sameAs(() => true),
    },
  },
  computed: {
    exampleImage() {
      return this.item.exampleImage
    },
    attachmentSrc() {
      return this.attachment ? URL.createObjectURL(this.attachment) : ''
    },
    isSalesforceForm () {
      const { form } = currentStoreView()
      return form === 'salesforce'
    },
    orgid () {
      return config.forms.orgid
    },
    salesforceEndpoint () {
      return config.forms.salesforceEndpoint
    },
    subsubjects() {
      if (this.subjects && this.subjects.length) {
        const subject = this.subjects.find(subject => +subject.value === +this.subject)
        if (subject)
          return subject.childs
        else
          return []
      }
    },
    regionOptions() {
      return this.USStates.map((item) => ({
        value: item.code,
        label: item.name,
      }))
    },
    localizedUrl() {
      return currentStoreView().url || ''
    },
    currentUser() {
      if (this.isLoggedIn) return this.$store.state.user.current
      else {
        return null
      }
    },
    currentCountry() {
      return currentStoreView().i18n.defaultCountry
    },
  },
  data () {
    return {
      loading: false,
      countryOptions: [],
      success: false,
      title: '',
      name: '',
      surname: '',
      kanjiFirstName: '',
      kanjiLastName: '',
      city: '',
      postcode: '',
      street: '',
      additionalStreet: '',
      region: '',
      country: '',
      email: '',
      phone: '',
      subject: this.item.defaultSubject,
      subsubject: null,
      message: '',
      phoneIndic: '',
      conditions: false,
      is_subscribed: false,
      subjects: [],
      USStates: [],
      watchRef: '',
      dialColor: '',
      attachment: null,
      MAX_FIRST_NAME_LENGTH,
      MAX_LAST_NAME_LENGTH,
      showForm: true
    }
  },
  methods: {
    ...mapActions('feedback', ['show']),
    ...mapGetters('user', ['isLoggedIn']),
    deleteImg(v) {
      this[v] = null
      this[v + 'Src'] = null
    },
    processFile (e) {
    this.attachment = e.target.files[0]
  },
    getCountriesOptions () {
      contactCountries().then((res) => {
        this.countryOptions = res.items.map((item) => {
          return { value: item.code, label: item.name }
        })
        if (this.item.limitedCountryList) {
          this.countryOptions = this.countryOptions.filter(({ value }) => (
            this.item.availableCountries && this.item.availableCountries.includes(value)
          ))
        }
      })
    },
    getSubjectList () {
      TaskQueue.execute({
        url: config.api.url + `/api/ext/contact/list?type=${this.item.subjectListType || 'contact_prismic'}`,
        payload: {
          method: 'GET',
          mode: 'cors',
          headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
          },
        },
      }).then((res) => {
        this.subjects = res.result.items
          .map((item) => {
            return { value: item.entity_id, label: item.subject, code: item.code, childs: item && item.childs && item.childs.length ? item.childs.map(child => ({ value: child.entity_id, label: this.$t(child.subject) })) : [] }
          })
      })
    },

    getSelectedSubject() {
      if (this.subject && this.subjects && this.subjects.length) {
        return this.subjects.find(subject => +subject.value === +this.subject)
      }
    },
    getShowForm() {
      this.showForm = this.item.limitedCountryList ? !this.item.hideFormUnavailableCountries : true
      if (!this.showForm) {
        const currentCountryCode = currentStoreView().i18n.defaultCountry
        this.showForm = this.item.availableCountries && this.item.availableCountries.includes(currentCountryCode)
      }
      return this.showForm
    },
    async submit () {
      const formAttachment = await saveAttachement(this.attachment)
      const form = this.item.fullAddress
        ? {
          civility: this.title,
          lastname: this.surname,
          firstname: this.name,
          kanjiFirstName: this.kanjiFirstName,
          kanjiLastName: this.kanjiLastName,
          country_id: this.country,
          city: this.city,
          postcode: this.postcode,
          street: this.street,
          street2: this.additionalStreet,
          region: this.region,
          email: this.email,
          phone: this.phoneIndic + this.phone,
          subject: this.subject,
          subsubject: this.subsubject,
          message: this.message,
          locale: currentStoreView().storeCode,
          watchRef: this.watchRef || this.item.watchRef,
          dialColor: this.dialColor,
          attachment: formAttachment
        }
        : {
          civility: this.title,
          lastname: this.surname,
          firstname: this.name,
          kanjiFirstName: this.kanjiFirstName,
          kanjiLastName: this.kanjiLastName,
          country_id: this.country,
          email: this.email,
          phone: this.phoneIndic + this.phone,
          subject: this.subject,
          subsubject: this.subsubject,
          message: this.message,
          locale: currentStoreView().storeCode,
          watchRef: this.watchRef || this.item.watchRef,
          dialColor: this.dialColor,
          attachment: formAttachment
        }
      const selectedSubject = this.getSelectedSubject()
      if (this.$v.$invalid) {
        this.$v.$touch()
        setTimeout(() => {
          let bodyRect = document.body.getBoundingClientRect()
          let elem = document.querySelector('.-error')
          elem.querySelector('select, input').focus()
          let elemRect = elem.getBoundingClientRect()
          let offset = elemRect.top - bodyRect.top - 140
          window.scrollTo({
            top: offset,
            behavior: 'smooth',
          })
        }, 1)
      } else {
        await this.$store.dispatch('googleRecaptcha/isVerifiedCaptcha')
        if (!this.$store.state.googleRecaptcha.is_verified) {
          this.show({ message: 'Recaptcha error. Please try again.', context: 'error' })
        } else {
          this.isLoading = true
          let promise = null
          if (!this.isSalesforceForm) {
            promise = TaskQueue.execute({
              url: config.api.url + '/api/ext/contact/send',
              payload: {
                method: 'POST',
                mode: 'cors',
                headers: {
                  Accept: 'application/json, text/plain, */*',
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(form),
              },
            })
          } else {
            const formAttachment = await saveAttachement(this.attachment);
            const formData = new FormData()
            formData.append('reason', this.subject)
            formData.append('00N2p000009f4qM', 'Local Site')
            formData.append('description', this.message)
            formData.append('00N2p000009f56o', this.is_subscribed)
            formData.append('phone', this.phoneIndic + this.phone)
            formData.append('00N2p000009f4qI', this.title)
            formData.append('00N2p000009f4q1', this.name)
            formData.append('00N2p000009f4q5', this.surname)
            formData.append('email', this.email)
            formData.append('00N2p000009f4py', this.country)
            formData.append('orgid', this.orgid)
            formData.append('00N2p000009f4qN', this.postcode)
            formData.append('00N2p000009f4pw', this.city)
            formData.append('00N2p000009f4pu', this.street + this.additionalStreet)
            formData.append('retUrl', 'http://google.com')
            formData.append('locale', currentStoreView().storeCode)
            formData.append('watchRef', this.watchRef || this.item.watchRef)
            formData.append('dialColor', this.dialColor)
            formData.append('attachment', formAttachment)
            promise = fetch(this.salesforceEndpoint, {
              method: 'POST',
              mode: 'cors',
              headers: {
                Accept: 'text/html;charset=UTF-8',
                'Content-Type': 'application/json',
              },
              body: formData
            })
          }
          promise
            .then(() => {
              this.$gtm.trackEvent(contactRequestObj({
                siteLocation: this.$route.name.substring(6).replace('-', ' ') + ' Page',
                requestType: this.subject || 'Customer Service',
                optinStatus: this.is_subscribed,
                email: this.email
              }))
              if (this.item.shippingKit && selectedSubject) {
                this.$gtm.trackEvent({
                  event: 'repair_journey_confirm',
                  repairCategory: selectedSubject.label,
                  repairReason: !!this.message,
                  productName: this.productName || undefined,
                  productId: this.productId || undefined
                })
              }
              this.show({ message: 'Your message has been sent successfully' })
              this.success = true
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              })
              if (this.is_subscribed) {
                return newsletter({ email: this.email, civility: this.title, firstname: this.name, lastname: this.surname, kanjiFirstName: this.kanjiFirstName, kanjiLastName: this.kanjiLastName, country: this.country })
                  .then(() => {
                    this.$gtm.trackEvent(newsletterEventObject({
                      siteLocation: this.$route.name.substring(6).replace('-', ' ') + ' Page',
                      email: this.email
                    }))
                  })
                  .catch((error) => {
                    this.show({ message: 'Newsletter registration failed', context: 'error' })
                    console.log('Newsletter registration failed', error)
                    this.isLoading = false
                  })
              } else {
                return null
              }
            })
            .catch((error) => {
              this.show({ message: 'Contact failed', context: 'error' })
              console.log('Contact failed', error)
              this.isLoading = false
            })
        }
      }
    },
  },
  created () {
    this.getShowForm()
    this.getSubjectList()
    this.getCountriesOptions()
  },
  mounted () {
    this.$v.$reset()
    USStates().then((data) => {
      this.USStates = data
    })
    if (this.currentUser) {
      this.title = this.currentUser.prefix || ''
      this.name = this.currentUser.lastname || ''
      this.surname = this.currentUser.firstname || ''
      this.country = this.currentUser.custom_attributes.filter((i) => i.attribute_code === 'country_id').length
        ? this.currentUser.custom_attributes.filter((i) => i.attribute_code === 'country_id')[0].value
        : ''
      this.email = this.currentUser.email || ''
      this.phone = this.currentUser.custom_attributes.filter((i) => i.attribute_code === 'phone').length ? this.currentUser.custom_attributes.filter((i) => i.attribute_code === 'phone')[0].value : ''
      this.is_subscribed = this.currentUser.extension_attributes.is_subscribed || false
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

// Fade
.fade-enter,
.fade-leave-to {
  position: static;
}

.container {
  margin-top: 10rem;
  margin-bottom: 14rem;

  @include bp(max md) {
    margin-bottom: 10rem;
  }

  .title{
    margin-bottom: 1rem;
    color: var(--zenith-theme-primary);
  }

  .subtitle {
    margin-bottom: 6rem;
    color: var(--zenith-component-text);
  }

  .wysiwyg {
    margin-bottom: 4rem;
    color: var(--zenith-component-text);
  }

  .form {
    color: var(--zenith-component-text);
  }

  .recaptcha {
    margin-bottom: 4rem;

    /deep/ a {
      color: var(--zenith-theme-primary);
      text-decoration: underline;
    }
  }
  .return-formfield {
    .watch-attachment {
      margin-top: 3rem;
      padding-bottom: 4rem;

      .-error .form-error {
        max-height: unset;
        opacity: 1;
        transform: none;
      }

      .picture {
        position: relative;
        display: flex;
        width: 100%;
        padding: 3rem 1rem;
        margin: 0 1rem;
        border: 1px dashed var(--zenith-grey);
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        text-align: center;
        transition: border 0.2s ease-in-out;
        color: var(--zenith-component-text);
          input {
            position: absolute;
            z-index: 0;
            opacity: 0;
          }
          & > img {
        position: absolute;
        z-index: 15;
        top: 0;
        right: 0;
        bottom:0;
        left: 0;
        width: 100%;
        height: 100%;
        max-width: none;
        object-fit: cover;
        background: black;
        object-fit: cover;
      }
      .trash {
        position: absolute;
        z-index: 20;
        left: 2rem;
        padding: 0;
        width: 2.8rem;
        bottom: 2rem;
        border: none;
        text-align: center;
        border-radius: 100%;
        background: rgba(255, 255, 255, 0.6);

        @include bp(max md) {
          left: 1rem;
          bottom: 1rem;
        }

        i {
          display: block;
          font-size: em(20);
          line-height: 2.8rem;
          color: var(--zenith-theme-primary);
        }

        &:hover,
        &:active,
        &:focus {
          background: rgba(255, 255, 255, 1);
        }
      }
      }
    }
    h3 {
      margin-bottom: 3rem;
    }
  }
}
</style>
